import { Body } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

interface Props {
  /** The chosen option's label; none shows the placeholder. */
  label?: string;
  placeholder: string;
  onOpen: (anchor: HTMLElement) => void;
  /** Extra classes, e.g. the table cell's padding and hover. */
  className?: string;
}

/**
 * A select value as plain text, never a tag chip: select options carry no
 * color. Clearing happens in the picker, not on the value.
 */
export const CustomFieldSelectValue = ({
  label,
  placeholder,
  onOpen,
  className,
}: Props) => (
  <button
    type="button"
    onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
      onOpen(e.currentTarget)
    }
    className={clsx(
      'flex max-w-full min-w-0 cursor-pointer items-center border-0 bg-transparent p-0 text-left',
      className,
    )}
  >
    <Body
      size="sm"
      tag="span"
      className={clsx(
        'truncate',
        label ? 'text-black-heading' : 'text-light-gray',
      )}
    >
      {label ?? placeholder}
    </Body>
  </button>
);
